import React, { useCallback, useEffect, useMemo, useState } from "react";



function ComingSoonPage() {
    return (
        <React.Fragment>

            <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
                <div className="xl:col-span-12">
                    <div className="card" id="attributeTable">
                        <div className="flex items-center justify-center border-dashed border-t border-b py-10">
                            <div className="text-center">
                                <h1 className="text-30 font-bold mb-5">Coming Soon</h1>
                                <p className="text-18 text-slate-600">
                                    This page is under development. Please check back soon.
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </div>


        </React.Fragment>
    );
}

export default ComingSoonPage;
